import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {NotificationToastService} from '../services/notifications/notification-toast.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastErrorModel} from '../models/toasts/toast-error.model';
import {ErrorInfos} from './error-infos';


@Injectable({
  providedIn: 'root',
})
export class DomainErrorInterceptorService implements HttpInterceptor {
  constructor(private notificationToastService: NotificationToastService) {}

  private static isDomainError(err: HttpErrorResponse): boolean {
    return err.error && err.error['isDomainError'] != null;
  }

  private extractInfos(err: HttpErrorResponse): Observable<any> {
    return new Observable<any>(observer => {
      if (DomainErrorInterceptorService.isDomainError(err)) {
        const title = err.status == 404 ? 'Ressource non trouvée' : null
        observer.error(new ErrorInfos(title, err.error.message));
      } else {
        observer.error(null)
      }
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((erreurBrute: HttpErrorResponse) => {
        return this.extractInfos(erreurBrute).pipe(
          catchError((erreurDecodee: ErrorInfos) => {
            if (erreurDecodee != null) {
              this.notificationToastService.push(new ToastErrorModel(erreurDecodee.content, erreurDecodee.title));
            }
            return throwError(erreurBrute);
          }),
        ) }
      ),
    );
  }
}
